<template>
    <div :class="cardClass">
        <template v-if="!isLoading">
            <div class="DonutCard__header-bar">
                <div class="DonutCard__header">
                    <slot name="header">
                        <span class="DonutCard__header-text">{{ header }}</span>
                        <RPTooltip
                            v-if="headerTooltip !== ''"
                            class="DonutCard__header-tooltip"
                            :tooltip="headerTooltip"
                        />
                    </slot>
                </div>
                <div class="DonutCard__title-action">
                    <slot name="action"></slot>
                </div>
            </div>
            <div class="DonutCard__content">
                <RPDonutChart
                    class="DonutCard__chart"
                    :chart-data="chartData"
                    :show-legend="showLegend"
                    :legend-position="legendPosition"
                    :show-total="showTotal"
                    :total-label="totalLabel"
                />
            </div>
        </template>
    </div>
</template>
<script>
import RPTooltip from 'components/Basic/Misc/RPTooltip.vue';
import RPDonutChart from './RPDonutChart.vue';
import stat from 'status';
import statusBuilder from 'status/statusBuilder';

export default {
    name: 'RPDonutCard',
    components: {
        RPTooltip,
        RPDonutChart
    },
    props: {
        header: {
            type: String,
            required: true
        },
        headerTooltip: {
            type: String,
            default: ''
        },
        chartData: {
            type: Array,
            required: true
        },
        showLegend: {
            type: Boolean,
            default: true
        },
        legendPosition: {
            type: String,
            default: 'bottom',
            validator: val => ['bottom', 'left', 'right'].indexOf(val) !== -1,
        },
        showTotal: {
            type: Boolean,
            default: true
        },
        totalLabel: {
            type: String,
            default: ''
        },
        status: {
            type: String,
            default: stat.STANDBY,
        }
    },
    computed: {
        isLoading(){
            return this.status === stat.LOADING;
        },
        cardClass(){
            return statusBuilder('DonutCard', this.status);
        },
    }
};
</script>
<style lang="scss">
    .DonutCard {
        position: relative;
        background: $white;

        @include loading(100%, 100%);

        min-width: 18rem;
        border-radius: 4px;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08);
        &__header-bar {
            display: flex;
            align-items: center;
            padding: 1rem 1rem 0 1rem;
        }
        &__header {
            display: flex;
            align-items: center;
            flex-grow: 1;
        }
        &__header-text {
            color: $text-dark;
            font-weight: 600;
        }
        &__header-tooltip {
            margin-left: 0.25rem;
        }
        &__content {
            position:absolute;
            bottom: 1rem;
            top: 3rem;
            left: 1rem;
            right: 1rem;
        }
        &__chart {
            height: 100%;
        }
    }
</style>
